import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Loan from '@containers/Loan';
import PayOff from '@containers/PayOff';
import Return from '@containers/Return';
import TrialBalance from '@containers/TrialBalance/TrialBalance';
import Home from '@containers/Home';
import Accounting from '@containers/Accounting';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/home.css';
import './style/style.css';
import '../node_modules/bootstrap/dist/js/bootstrap.min.js';
import '../node_modules/bootstrap-icons/font/bootstrap-icons.css';
function App() {
    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/loan" element={<Loan />} />
                <Route path="/payoff" element={<PayOff />} />
                <Route path="/return" element={<Return />} />
                <Route path="/trialbalance" element={<TrialBalance />} />
                <Route path="/accounting" element={<Accounting />} />
            </Routes>
        </div>
    );
}

export default App;
